/**
 * Convert array to array of object
 * @param {Array} items
 * @return {Array} of object combined values.
 */
export const convertToOptions = items =>
  items.map(item => ({
    label: item,
    value: item,
  }))

/**
 * Excludes the value depending on the selections and converts them to the acceptable form
 * @param {Array} filterOptions dates
 * @param {String} formTo last date
 * @param {String} formFrom first date
 * @return {Object} available values

 */
export const getParametersFilters = ({ filterOptions, formTo, formFrom }) => {
  const fromRange = filterOptions.slice(0, filterOptions.indexOf(formTo))
  const toRange = filterOptions.slice(
    filterOptions.indexOf(formFrom) + 1,
    filterOptions.length + 1,
  )

  const from = convertToOptions(fromRange)
  const to = convertToOptions(toRange)

  return { from, to }
}

/**
 * Filter data by Range and convert date to value
 * @param {Array} rangeDatesList array of date
 * @param {Object} resultsByDate hash map with data and values
 * @return {Array} values.
 */
export const filterDataByRange = (rangeDatesList, resultsByDate) =>
  rangeDatesList.map(date => resultsByDate[date])

/**
 * Get differences in array of numbers
 * @param {Array} values array of numbers
 * @return {Array} array of differences
 */
export const getDifferences = values => {
  const arrDifferences = []
  for (let i = 0; i < values.length - 1; i++) {
    arrDifferences.push(values[i + 1] - values[i])
  }
  return arrDifferences
}

export const numberToThousand = value => `${Math.trunc(value / 1000)}K`
